import { render, staticRenderFns } from "./render-config-tab.vue?vue&type=template&id=3493c5ba&scoped=true"
import script from "./render-config-tab.vue?vue&type=script&lang=js"
export * from "./render-config-tab.vue?vue&type=script&lang=js"
import style0 from "./render-config-tab.vue?vue&type=style&index=0&id=3493c5ba&prod&scoped=true&lang=css"
import style1 from "./render-config-tab.vue?vue&type=style&index=1&id=3493c5ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3493c5ba",
  null
  
)

export default component.exports